module.exports = __webpack_public_path__ + "img/166.14ea6a1e.jpg";